// extracted by mini-css-extract-plugin
export var deliveryRow = "_nz-a";
export var fixedHeight = "_nz-4";
export var freightLogo = "_nz-9";
export var fullWidth = "_nz-3";
export var priceColumn = "_nz-5";
export var radioSelected = "_nz-7";
export var radioUnselected = "_nz-6";
export var selectedOption = "_nz-2";
export var selectedOptionContainer = "_nz-1";
export var selection = "_nz-0";
export var tallSkeletonText = "_nz-8";